<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align:left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<Uploader :url="url" :meta="sampleData" :complete="complete"></Uploader>
				</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import Uploader from "@/components/Uploader";

export default {
	name: "UploaderTest",

	props: [],

	components: { MainPage, AdminNav, Uploader },

	data() {
		return {
			sampleData: {
				someData: "That will get posted"
			},
			url: "/v1/upload_test"
		};
	},

	methods: {
		complete() {
			alert("COMPLETE");
		},
		error() {
			alert("ERROR");
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
